// extracted by mini-css-extract-plugin
export default {"offer":"H67FRDTh9Xy7hLL660f5","subtitle":"yUjo13qT0cvGPyjvWI0C","alert":"ZQ87GckTMlBq0FYiNF8E"};